import { useState } from "react";
import { lazyWithPreload } from "utils/lazyWithPreload";

import { usePreloadComponents } from "hooks/usePreloadedComponents";

import { WizardDataType } from "../../IngestionWizard/types";

const IngestionWizard = lazyWithPreload(
  () => import("components/IngestionWizard/IngestionWizard")
);

export const useLoadData = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [initialData, setInitialData] = useState<
    Partial<WizardDataType> | undefined
  >(undefined);

  usePreloadComponents([IngestionWizard]);

  const openLoadData = (wizardInitialData?: Partial<WizardDataType>) => {
    setInitialData(wizardInitialData);
    setOpen(true);
  };

  const closeCreateUser = () => {
    setOpen(false);
  };

  const loadDataMarkup = open ? (
    <IngestionWizard
      onClose={closeCreateUser}
      wizardInitialData={initialData}
    />
  ) : null;

  return {
    loadDataMarkup,
    openLoadData,
  };
};
